

import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import CssBaseline from '@material-ui/core/CssBaseline';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Paper from '@material-ui/core/Paper';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import AddressForm from './AddressForm';
import PaymentForm from './PaymentForm';
import Review from './Review';
import UserForm from "./UserForm";
import CreditCardForm from "./CreditCardForm";
import VehicleForm from "./VehicleForm";
import BankAccountForm from "./BankAccountForm";
import MessageForm from "./MessageForm";
import CompanyInfoForm from "./CompanyInfoForm";
import green from '@material-ui/core/colors/green';
import Radio from '@material-ui/core/Radio';
import RadioButtonUncheckedIcon from '@material-ui/icons/RadioButtonUnchecked';
import RadioButtonCheckedIcon from '@material-ui/icons/RadioButtonChecked';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import RadioGroup from '@material-ui/core/RadioGroup';
import CCTransactionForm from "./CCTransactionForm";
import PoliceInfoForm from "./PoliceInfoForm";
import StorageLotInfoForm from "./StorageLotInfoForm";
import TowCompanyTrucksForm from "./TowCompanyTrucksForm";
import CompanyPropertyInfoForm from "./CompanyPropertyInfoForm";
import TowCompanyDriversForm from "./TowCompanyDriversForm";

import StepButton from "@material-ui/core/StepButton";
import {USER_TYPE} from "../../utils/MainConstants";



/*import CameraForm from "./CameraForm";
import VideoControllerForm from "./VideoControllerForm";
import LocationForm from "./LocationForm";
import ProcessForm from "./ProcessForm";
import StreamForm from "./StreamForm";
import VideoServerForm from "./VideoServerForm";
*/

const styles = theme => ({
    appBar: {
        position: 'relative',
    },
    layout: {
        width: 'auto',
        marginLeft: theme.spacing.unit * 2,
        marginRight: theme.spacing.unit * 2,
        [theme.breakpoints.up(600 + theme.spacing.unit * 2 * 2)]: {
            width: '100%',
            marginLeft: 'auto',
            marginRight: 'auto',
        },
    },
    paper: {
        marginTop: theme.spacing.unit * 0,
        marginBottom: theme.spacing.unit * 1,
        padding: theme.spacing.unit * 2,
        [theme.breakpoints.up(600 + theme.spacing.unit * 3 * 2)]: {
            marginTop: theme.spacing.unit * 6,
            marginBottom: theme.spacing.unit * 6,
            padding: theme.spacing.unit * 3,
        },
    },
    stepper: {
        padding: `${theme.spacing.unit * 3}px 0 ${theme.spacing.unit * 5}px`,
    },
    buttons: {
        display: 'flex',
        justifyContent: 'flex-end',
    },
    button: {
        marginTop: theme.spacing.unit * 3,
        marginLeft: theme.spacing.unit,
        textTransform: "unset !important",
    },
});


const steps = ['User Info', 'Credit Card', 'Company', 'Police', 'Storage Lot', 'Property', 'Trucks', 'Drivers'];



class TowCompanyConfiguration extends React.Component {
    state = {
        activeStep: 0,
        selectedValue: 'towagent',
    };

    constructor(props) {
        super(props);
        this.getStepContent=this.getStepContent.bind(this);
    }



    getStepContent(step) {
        switch (step) {
            case 0:
                return(<UserForm usertype={USER_TYPE.TOW_TRUCK_AGENT_USER_TYPE}> </UserForm>);
            case 1:
                return <CreditCardForm/>;
            case 2:
                return <CompanyInfoForm/>;
            case 3:
                return <PoliceInfoForm/>;
            case 4:
                return <StorageLotInfoForm/>;
            case 5:
                return <CompanyPropertyInfoForm/>;
            case 6:
                return <TowCompanyTrucksForm/>;
            case 7:
                return <TowCompanyDriversForm/>;
            default:
                throw new Error('Unknown step');
        }
    }
    
    
    
    handleNext = () => {
        this.setState(state => ({
            activeStep: state.activeStep + 1,
        }));
    };

    handleBack = () => {
        this.setState(state => ({
            activeStep: state.activeStep - 1,
        }));
    };

    //This was done so by clicking on the number or text it would jump
    //to the actuall subpage- like credit card, company, Police and ...
    /*handleStep = (event) => {
        const { param } = event.target.dataset;
        var tempValue = event.currentTarget.textContent;
        var tempVar2 =  tempValue.substring(1,tempValue.length) ;
        var tempVar3=0;
        for(var i=0; i<steps.length; i++){

           if( steps[i].includes(tempVar2)>0){
               tempVar3=i;
           }
        }


        event.stopPropagation();
        this.setState(state => ({
            activeStep:tempVar3
        }));
    };*/


    handleStep = step => () => {
        //setActiveStep(step);
        //event.stopPropagation();
        this.setState(state => ({
            activeStep:step
        }));
    };



    handleReset = () => {
        this.setState({
            activeStep: 0,
        });
    };


    componentDidMount() {
        window.scrollTo(0, 0)
    }

    handleChange = event => {
        this.setState({ selectedValue: event.target.value });
    };

    render() {
        const { classes } = this.props;
        const { activeStep } = this.state;

        return (
            <React.Fragment>
            <CssBaseline />
            {/* <AppBar position="absolute" color="default" className={classes.appBar}>
                <Toolbar>
                    <Typography variant="h6" color="inherit" noWrap>
                        PlateWiz&trade; Configuration
                    </Typography>
                </Toolbar>
            </AppBar>
            */}
            <div className={classes.layout}>
            <Paper className={classes.paper}>
                <Typography component="h1" variant="h4" align="center">
               Tow Company Configuration
                </Typography>

        <div className={classes.buttons}>
            {activeStep !== 0 && (
            <Button onClick={this.handleBack} className={classes.button}>
            Back
            </Button>
    )}
        {activeStep != (steps.length - 1) && (<Button
        variant="contained"
        color="primary"
        onClick={this.handleNext}
        className={classes.button}
        >
        {activeStep === steps.length - 1 ? 'Save Configuration' : 'Next'}
    </Button>)}
        </div>


        {/*
                <FormControl component="fieldset" className={classes.formControl}>
                    <FormLabel component="legend">User Type</FormLabel>
                    <RadioGroup
                        aria-label="gender"
                        name="usertype"
                        className={classes.group}
                        value={this.state.value}
                        onChange={this.handleChange}
                            >
                    <FormControlLabel
                        value="vehicleowner"
                        control={<Radio color="primary"   />}
                        label="Vehicle Ower"
                        labelPlacement="end"
                            />
                    <FormControlLabel
                        value="towagent"
                        control={<Radio color="primary"    />}
                        label="Tow Agent"
                        labelPlacement="end"
                            />
                    </RadioGroup>
                </FormControl>

            */}

        <Stepper alternativeLabel nonLinear activeStep={activeStep}>
            {steps.map((label, index) => {
                    const stepProps = {};
                    const buttonProps = {};

                    return (
                        <Step key={label} {...stepProps}>
                <StepButton
                    onClick={this.handleStep(index)}
                    {...buttonProps}
                >
                    {label}
                </StepButton>
                    </Step>
                );
                })}
            </Stepper>


            {/*
            <Stepper activeStep={activeStep} className={classes.stepper}>
            {steps.map(label => (
                    <Step key={label} value={label} onClick={this.handleStep}>
                <StepLabel >{label}</StepLabel>
                </Step>
                ))}
                </Stepper>

                */}
        <React.Fragment>
        {activeStep === steps.length ? (
            <React.Fragment>
            <Typography variant="h5" gutterBottom>
        Thank you for your order.
        </Typography>
        <Typography variant="subtitle1">
            Your order number is #2001539. We have emailed your order confirmation, and will
        send you an update when your order has shipped.
        </Typography>
        </React.Fragment>
                ) : (
        <React.Fragment>
        {this.getStepContent(activeStep)}
        <div className={classes.buttons}>
            {activeStep !== 0 && (
            <Button onClick={this.handleBack} className={classes.button}>
            Back
            </Button>
    )}
            {activeStep != (steps.length - 1) && ( <Button
        variant="contained"
        color="primary"
        onClick={this.handleNext}
        className={classes.button}
        >
        {activeStep === steps.length - 1 ? 'Save Configuration' : 'Next'}
    </Button> )}
        </div>
        </React.Fragment>
    )}
    </React.Fragment>
        </Paper>
        </div>
        </React.Fragment>
    );
    }
}

TowCompanyConfiguration.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(TowCompanyConfiguration);